import React, { useMemo } from "react";
import type { ProductImageGalleryBlock as ProductImageGalleryBlockType } from "@/types/content";
import { useProduct } from "@/hooks/useProduct";
import { variantCarouselItems } from "@/types/product";
import { ProductMediaGallery } from "@/components/content/ProductPage/ProductMediaGallery";

export interface ProductImageGalleryBlockProps {
  block: ProductImageGalleryBlockType;
}

export const ProductImageGalleryBlock: React.FC<
  ProductImageGalleryBlockProps
> = () => {
  const { productData, selectedVariant } = useProduct();

  const productName = productData.name ?? "Product";

  // A variant with its own images takes over the gallery (a red collar shows
  // red photos). Variants without images keep the product's own media.
  const items = useMemo(() => {
    const variantItems = variantCarouselItems(selectedVariant);
    if (variantItems.length) return variantItems;
    return productData.compositions?.productContent?.carouselItems ?? [];
  }, [selectedVariant, productData]);

  return <ProductMediaGallery items={items} productName={productName} />;
};

export default ProductImageGalleryBlock;
